import api from "./api";

const TOKEN_KEY = "dm_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => ({ Authorization: `Bearer ${getToken()}` });

export const formatApiError = (detail) => {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
};

export const adminLogin = async (email, password) => {
  const { data } = await api.post("/auth/login", { email, password });
  setToken(data.token);
  return data.user;
};

export const adminMe = async () => (await api.get("/auth/me", { headers: authHeader() })).data;

export const adminListProducts = async () =>
  (await api.get("/admin/products", { headers: authHeader() })).data;

export const adminCreateProduct = async (payload) =>
  (await api.post("/admin/products", payload, { headers: authHeader() })).data;

export const adminUpdateProduct = async (id, payload) =>
  (await api.put(`/admin/products/${id}`, payload, { headers: authHeader() })).data;

export const adminDeleteProduct = async (id) =>
  (await api.delete(`/admin/products/${id}`, { headers: authHeader() })).data;

export const adminUploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd, {
    headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
  });
  return data.url;
};

export const adminSaveSite = async (payload) =>
  (await api.put("/admin/site", payload, { headers: authHeader() })).data;
